import React, { useEffect, useState } from 'react';
import './Vikrireportprint.css';
import axios from 'axios';
import { Document, Page, Text, View, StyleSheet, PDFViewer, Image, Font } from '@react-pdf/renderer';
import { useTranslation } from "react-i18next";

import Baloo2Font from "../../Fonts/Baloo2-VariableFont_wght.ttf";
import NotoSansKannada from "../../Fonts/NotoSansKannada.ttf";   // ✅ add this font in your Fonts folder
import Logo from "../../imgs/dairylogo.png";

// ✅ Register fonts for PDF
Font.register({ family: 'Baloo2', src: Baloo2Font });
Font.register({ family: 'NotoSansKannada', src: NotoSansKannada });

const Vikrireportprint = () => {
  const { t, i18n } = useTranslation();

  const lang = (i18n?.language || localStorage.getItem("i18nextLng") || "mr").toLowerCase();
  const isKn = lang.startsWith("kn");

  const PDF_FONT = isKn ? "NotoSansKannada" : "Baloo2";

  const [customerData, setCustomerData] = useState([]);
  const [PreviousAmt, setPreviousAmt] = useState(0);

  let totals = {};

  useEffect(() => {
    var mainuser2 = jsEncode.encode("mamapr", 125);
    let phplanding = "";

    // ✅ landing selection (kept same logic but fixed kirkol missing condition)
    if (localStorage.getItem("rtype") === "sanghvikri") {
      phplanding = "getsanghvikrireport.php";
    }
    if (localStorage.getItem("rtype") === "ratibvikri" && localStorage.getItem("ratibtype") === "ratibvikrisabh") {
      phplanding = "getratibvikrisabh2.php";
    }
    if (localStorage.getItem("rtype") === "ratibvikri" && localStorage.getItem("ratibtype") === "ratibvikrigr") {
      phplanding = "getratibvikrigr.php";
    }
    if (localStorage.getItem("rtype") === "statement" && localStorage.getItem("ratibtype") === "ratibvikrisabh") {
      phplanding = "getratibsabhstatement.php";
    }
    if (localStorage.getItem("rtype") === "statement" && localStorage.getItem("ratibtype") === "ratibvikrigr") {
      phplanding = "getratibgrstatement.php";
    }
    if (localStorage.getItem("rtype") === "kirkol") {
      phplanding = "getkirkolvikrireport.php";
    }
    if (localStorage.getItem("rtype") === "ratiball" && localStorage.getItem("ratibtype") === "ratibvikrisabh") {
      phplanding = "getratibyenebakiyadisabh.php";
    }
    if (localStorage.getItem("rtype") === "ratiball" && localStorage.getItem("ratibtype") === "ratibvikrigr") {
      phplanding = "getratibyenebakiyadi.php";
    }

    let rawData = {
      date1: localStorage.getItem("date1print"),
      date2: localStorage.getItem("date2print"),
      rno: localStorage.getItem("rno"),
      kno: localStorage.getItem("rno"),
      grtype: localStorage.getItem("grtype"),
      mainuser: localStorage.getItem("contact"),
      mainuser2: mainuser2,
    };

    rawData = JSON.stringify(rawData);
    let formData = new FormData();
    formData.append('data', rawData);

    axios.post(`https://excellentdairy.com/dairy/php/cust/${phplanding}`, formData, {
      'Content-Type': 'multipart/form-data',
    }).then(function sample(response) {
      const data = Array.isArray(response.data) ? response.data : [];
      if (localStorage.getItem("rtype") === "kirkol" && data.length > 0) {
        // prevamt is in first row
        setPreviousAmt(parseFloat(data[0].prevamt || 0));
      }
      setCustomerData(data);
    }).catch(err => {
      console.log(err);
      setCustomerData([]);
    });
  }, []);

  function formatDate(inputDate) {
    try {
      const options = { day: '2-digit', month: 'short', year: 'numeric' };
      return new Date(inputDate).toLocaleDateString('en-US', options);
    } catch {
      return inputDate || "";
    }
  }

  // ✅ totals
  const rtype = localStorage.getItem("rtype");
  const ratibtype = localStorage.getItem("ratibtype");

  if (rtype === "sanghvikri") {
    if (Array.isArray(customerData) && customerData.length > 0) {
      totals = {
        tliter: customerData.reduce((total, row) => total + parseFloat(row.liter || 0), 0),
        tamt: customerData.reduce((total, row) => total + parseFloat(row.amt || 0), 0),
      };
    }
  } else if (rtype === "ratibvikri" && (ratibtype === "ratibvikrisabh" || ratibtype === "ratibvikrigr")) {
    if (Array.isArray(customerData) && customerData.length > 0) {
      totals = {
        tliter: customerData.reduce((total, row) => total + parseFloat(row.liter || 0), 0),
        tamt: customerData.reduce((total, row) => total + parseFloat(row.amt || 0), 0),
      };
    }
  } else if (rtype === "statement" && (ratibtype === "ratibvikrisabh" || ratibtype === "ratibvikrigr")) {
    if (Array.isArray(customerData) && customerData.length > 0) {
      totals = {
        nave: customerData.reduce((total, row) => total + parseFloat(row.nave || 0), 0),
        jma: customerData.reduce((total, row) => total + parseFloat(row.jma || 0), 0),
      };
    }
  } else if (rtype === "kirkol") {
    if (Array.isArray(customerData) && customerData.length > 0) {
      const running = customerData.reduce((total, row) => {
        const amt = parseFloat(row.amt || 0);
        if (row.trantype === "Debit") return total + amt;
        return total - amt;
      }, 0);
      totals = {
        tliter: customerData.reduce((total, row) => total + parseFloat(row.liter || 0), 0),
        tamt: (running + parseFloat(PreviousAmt || 0)).toFixed(2),
      };
    }
  } else if (rtype === "ratiball") {
    if (Array.isArray(customerData) && customerData.length > 0) {
      totals = {
        mhliter: customerData.reduce((total, row) => total + parseFloat(row.mhliter || 0), 0),
        gayliter: customerData.reduce((total, row) => total + parseFloat(row.gayliter || 0), 0),
        tliter: customerData.reduce((total, row) => total + parseFloat(row.tliter || 0), 0),
        ryenebaki: customerData.reduce((total, row) => total + parseFloat(row.ryenebaki || 0), 0).toFixed(2),
      };
    }
  }

  var jsEncode = {
    encode: function (s, k) {
      var enc = "";
      var str = s.toString();
      for (var i = 0; i < str.length; i++) {
        var a = str.charCodeAt(i);
        var b = a ^ k;
        enc = enc + String.fromCharCode(b);
      }
      return enc;
    }
  };

  const chunk = (arr, size = 30) =>
    Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
      arr.slice(i * size, i * size + size)
    );

  const pages = chunk(customerData, 30);

  // ✅ small helper: make styles dependent on language font
  const s = makeStyles(PDF_FONT);

  return (
    <PDFViewer className='pdf'>
      <Document>

        {customerData && customerData.length > 0 ? (
          rtype === "sanghvikri" ? (
            <Page size="A4" orientation="landscape" style={s.landscapePage}>
              <Text style={s.title}>{customerData[0]?.kendra || ""}</Text>
              <Text style={s.title}>{t("vikrireportprint.titles.unionSaleReport")}</Text>
              <Text style={s.subTitle}>
                {t("vikrireportprint.labels.period") + " : " + formatDate(localStorage.getItem("date1print")) + "   " + t("common.to") + "   " + formatDate(localStorage.getItem("date2print"))}
              </Text>

              <View style={s.imagerow}>
                <Text style={s.imgtext}>{t("vikrireportprint.labels.poweredBy")}</Text>
                <Image style={s.image} src={Logo} />
              </View>

              <View style={s.table}>
                <View style={s.tableRow}>
                  <Text style={s.th}>{t("common.table.date")}</Text>
                  <Text style={s.th}>{t("common.table.name")}</Text>
                  <Text style={s.th}>{t("common.table.time")}</Text>
                  <Text style={s.th}>{t("common.table.type")}</Text>
                  <Text style={s.th}>{t("common.table.liter")}</Text>
                  <Text style={s.th}>{t("common.table.fat")}</Text>
                  <Text style={s.th}>{t("common.table.snf")}</Text>
                  <Text style={s.th}>{t("common.table.rate")}</Text>
                  <Text style={s.thLast}>{t("common.table.amount")}</Text>
                </View>

                {customerData.map((row, index) => (
                  <View key={index} style={s.tableRow}>
                    <Text style={s.td}>{(row.date || "").substr(5).split('-').reverse().join('/')}</Text>
                    <Text style={s.td}>{(row.sno || "") + ": " + (row.sname || "")}</Text>
                    <Text style={s.td}>{row.time || "-"}</Text>
                    <Text style={s.td}>{row.type || "-"}</Text>
                    <Text style={s.td}>{row.liter || "0"}</Text>
                    <Text style={s.td}>{row.fat || "0"}</Text>
                    <Text style={s.td}>{row.snf || "0"}</Text>
                    <Text style={s.td}>{row.rate || "0"}</Text>
                    <Text style={s.td}>{row.amt || "0"}</Text>
                  </View>
                ))}

                <View style={s.totalRow}>
                  <Text style={s.th}>{t("common.total")}</Text>
                  <Text style={s.th}>-</Text>
                  <Text style={s.th}>-</Text>
                  <Text style={s.th}>-</Text>
                  <Text style={s.th}>{parseFloat(totals.tliter || 0).toFixed(2)}</Text>
                  <Text style={s.th}>-</Text>
                  <Text style={s.th}>-</Text>
                  <Text style={s.th}>-</Text>
                  <Text style={s.thLast}>{parseFloat(totals.tamt || 0).toFixed(2)}</Text>
                </View>
              </View>
            </Page>
          ) : rtype === "ratibvikri" && (ratibtype === "ratibvikrisabh" || ratibtype === "ratibvikrigr") ? (
            <>
              {pages.map((rows, pageIndex) => (
                <Page key={pageIndex} size="A4" style={s.page}>
                  <View style={s.pageInner}>
                    <Text style={s.title}>{customerData[0]?.kendra || ""}</Text>
                    <Text style={s.title}>{t("vikrireportprint.titles.ratibReport")}</Text>
                    <Text style={s.subTitle}>
                      {t("vikrireportprint.labels.period") + " : " + formatDate(localStorage.getItem("date1print")) + "   " + t("common.to") + "   " + formatDate(localStorage.getItem("date2print"))}
                    </Text>

                    <View style={s.tableRow}>
                      <Text style={s.th}>{t("common.table.date")}</Text>
                      <Text style={s.th}>{t("common.table.time")}</Text>
                      <Text style={s.th}>{t("common.table.account_no")}</Text>
                      <Text style={s.th}>{t("common.table.name")}</Text>
                      <Text style={s.th}>{t("common.table.type")}</Text>
                      <Text style={s.th}>{t("common.table.liter")}</Text>
                      <Text style={s.th}>{t("common.table.rate")}</Text>
                      <Text style={s.thLast}>{t("common.table.amount")}</Text>
                    </View>

                    {rows.map((row, idx) => (
                      <View key={idx} style={s.tableRow}>
                        <Text style={s.td}>{(row.date || "").substr(5).split("-").reverse().join("/")}</Text>
                        <Text style={s.td}>{row.time || "-"}</Text>
                        <Text style={s.td}>{row.rno || "-"}</Text>
                        <Text style={s.td}>
                          {ratibtype === "ratibvikrisabh" ? (row.cname || "-") : (row.rname || "-")}
                        </Text>
                        <Text style={s.td}>{row.type || "-"}</Text>
                        <Text style={s.td}>{row.liter || "0"}</Text>
                        <Text style={s.td}>{row.rate || "0"}</Text>
                        <Text style={s.td}>{row.amt || "0"}</Text>
                      </View>
                    ))}

                    {pageIndex === pages.length - 1 && (
                      <View style={s.totalRow}>
                        <Text style={s.th}>{t("common.total")}</Text>
                        <Text style={s.th}>-</Text>
                        <Text style={s.th}>-</Text>
                        <Text style={s.th}>-</Text>
                        <Text style={s.th}>-</Text>
                        <Text style={s.th}>{parseFloat(totals.tliter || 0).toFixed(2)}</Text>
                        <Text style={s.th}>-</Text>
                        <Text style={s.thLast}>{parseFloat(totals.tamt || 0).toFixed(2)}</Text>
                      </View>
                    )}
                  </View>
                </Page>
              ))}
            </>
          ) : rtype === "statement" && (ratibtype === "ratibvikrisabh" || ratibtype === "ratibvikrigr") ? (
            <Page size="A4" style={s.page}>
              <Text style={s.title}>{customerData[0]?.kendra || ""}</Text>
              <Text style={s.title}>{t("vikrireportprint.titles.ratibLedger")}</Text>
              <Text style={s.subTitle}>
                {t("vikrireportprint.labels.account") + "- " + (localStorage.getItem("rno") || "") + " " + (customerData[0]?.cname || "")}
              </Text>
              <Text style={s.subTitle}>
                {t("vikrireportprint.labels.period") + " : " + formatDate(localStorage.getItem("date1print")) + "   " + t("common.to") + "   " + formatDate(localStorage.getItem("date2print"))}
              </Text>

              <View style={s.tableRow}>
                <Text style={s.th}>{t("common.table.date")}</Text>
                <Text style={s.thSecond}>{t("vikrireport.table.particular")}</Text>
                <Text style={s.th}>{t("vikrireport.table.debit")}</Text>
                <Text style={s.th}>{t("vikrireport.table.credit")}</Text>
                <Text style={s.thLast}>{t("common.balance")}</Text>
              </View>

              {customerData.map((row, index) => (
                <View key={index} style={s.tableRow}>
                  <Text style={s.td}>{(row.date || "").substr(5).split('-').reverse().join('/')}</Text>
                  <Text style={s.tdSecond}>{(row.particular || "") + "\n" + (row.remark || "")}</Text>
                  <Text style={s.td}>{parseFloat(row.nave || 0).toFixed(2)}</Text>
                  <Text style={s.td}>{parseFloat(row.jma || 0).toFixed(2)}</Text>
                  <Text style={s.td}>{parseFloat(row.closing_balance || 0).toFixed(2)}</Text>
                </View>
              ))}

              <View style={s.totalRow}>
                <Text style={s.th}>{t("common.total")}</Text>
                <Text style={s.thSecond}>-</Text>
                <Text style={s.th}>{parseFloat(totals.nave || 0).toFixed(2)}</Text>
                <Text style={s.th}>{parseFloat(totals.jma || 0).toFixed(2)}</Text>
                <Text style={s.thLast}>-</Text>
              </View>
            </Page>
          ) : (
            <Page size="A4" style={s.page}>
              <Text style={s.title}>{customerData[0]?.kendra || ""}</Text>
              <Text style={s.title}>{t("vikrireportprint.titles.ratibReceivableList")}</Text>
              <Text style={s.subTitle}>
                {t("vikrireportprint.labels.period") + " : " + formatDate(localStorage.getItem("date1print")) + "   " + t("common.to") + "   " + formatDate(localStorage.getItem("date2print"))}
              </Text>

              <View style={s.tableRow}>
                <Text style={s.th}>{t("common.table.account_no")}</Text>
                <Text style={s.th}>{t("common.table.name")}</Text>
                <Text style={s.th}>{t("vikrireport.table.buffaloLiter")}</Text>
                <Text style={s.th}>{t("vikrireport.table.cowLiter")}</Text>
                <Text style={s.th}>{t("vikrireport.table.totalLiter")}</Text>
                <Text style={s.thLast}>{t("vikrireport.table.totalReceivable")}</Text>
              </View>

              {customerData.map((row, index) => (
                <View key={index} style={s.tableRow}>
                  <Text style={s.td}>{row.rno || "-"}</Text>
                  <Text style={s.td}>{row.rname || "-"}</Text>
                  <Text style={s.td}>{parseFloat(row.mhliter || 0).toFixed(2)}</Text>
                  <Text style={s.td}>{parseFloat(row.gayliter || 0).toFixed(2)}</Text>
                  <Text style={s.td}>{parseFloat(row.tliter || 0).toFixed(2)}</Text>
                  <Text style={s.td}>{parseFloat(row.ryenebaki || 0).toFixed(2)}</Text>
                </View>
              ))}

              <View style={s.totalRow}>
                <Text style={s.th}>{t("common.total")}</Text>
                <Text style={s.th}>-</Text>
                <Text style={s.th}>{parseFloat(totals.mhliter || 0).toFixed(2)}</Text>
                <Text style={s.th}>{parseFloat(totals.gayliter || 0).toFixed(2)}</Text>
                <Text style={s.th}>{parseFloat(totals.tliter || 0).toFixed(2)}</Text>
                <Text style={s.thLast}>{parseFloat(totals.ryenebaki || 0).toFixed(2)}</Text>
              </View>
            </Page>
          )
        ) : (
          ""
        )}
      </Document>
    </PDFViewer>
  );
};

const makeStyles = (FONT_FAMILY) => StyleSheet.create({
  page: {
    paddingTop: 10,
    paddingHorizontal: 20,
  },
  landscapePage: {
    paddingTop: 10,
    paddingHorizontal: 20,
  },
  pageInner: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  table: {
    display: 'table',
    width: '100%',
    marginTop: 8,
  },
  tableRow: {
    flexDirection: 'row',
  },
  th: {
    fontFamily: FONT_FAMILY,
    fontWeight: 700,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    borderRightWidth: 0,
    borderStyle: 'solid',
    borderColor: '#000',
    padding: 2,
    flex: 1,
    textAlign: 'center',
    fontSize: 9,
  },
  thLast: {
    fontFamily: FONT_FAMILY,
    fontWeight: 700,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderStyle: 'solid',
    borderColor: '#000',
    padding: 2,
    flex: 1,
    textAlign: 'center',
    fontSize: 9,
  },
  thSecond: {
    fontFamily: FONT_FAMILY,
    fontWeight: 700,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    borderRightWidth: 0,
    borderStyle: 'solid',
    borderColor: '#000',
    padding: 2,
    textAlign: 'center',
    fontSize: 9,
    width: 250,
  },
  td: {
    borderWidth: 0.5,
    borderColor: 'lightgray',
    padding: 1,
    flex: 1,
    fontSize: 9.5,
    fontFamily: FONT_FAMILY,
    textAlign: 'center',
  },
  tdSecond: {
    borderWidth: 0.5,
    borderColor: 'lightgray',
    padding: 2,
    paddingLeft: 8,
    fontSize: 9.5,
    fontFamily: FONT_FAMILY,
    textAlign: 'left',
    width: 250,
  },
  totalRow: {
    flexDirection: 'row',
    backgroundColor: 'lightgray',
    marginTop: 8,
  },
  title: {
    fontFamily: FONT_FAMILY,
    fontSize: 14,
    marginBottom: 4,
    textAlign: 'center',
    fontWeight: 700,
  },
  subTitle: {
    fontFamily: FONT_FAMILY,
    fontSize: 11,
    textAlign: 'center',
    fontWeight: 700,
  },
  imagerow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 4,
  },
  image: {
    width: 80,
    height: "auto",
    marginLeft: 5,
    marginTop: 2
  },
  imgtext: {
    fontFamily: FONT_FAMILY,
    fontSize: 9,
    fontWeight: 700,
    textAlign: 'center',
  },
});

export default Vikrireportprint;
